var map = {
	"./css/fonts.css": "87b8",
	"./css/layout.css": "0789",
	"./css/overlay.css": "bad7",
	"./css/resets.css": "3325",
	"./css/vars.css": "fa77",
	"./fonts/Circle/Circe-Bold.woff": "90f0",
	"./fonts/Circle/Circe-Bold.woff2": "dfc6",
	"./fonts/Circle/Circe-ExtraBold.woff": "0842",
	"./fonts/Circle/Circe-ExtraBold.woff2": "4a0b",
	"./fonts/Circle/Circe-Light.woff": "6d4b",
	"./fonts/Circle/Circe-Light.woff2": "287d",
	"./fonts/Circle/Circe-Regular.woff": "4452",
	"./fonts/Circle/Circe-Regular.woff2": "aea8",
	"./images/arrow-left-alt.svg": "2f86",
	"./images/arrow-right-alt.svg": "ce4c",
	"./images/automatization-dude.svg": "e40c",
	"./images/best-conditions-dudes.svg": "7f18",
	"./images/bg/board.svg": "6ad8",
	"./images/bg/dotted_arrow.svg": "843e",
	"./images/bg/slider.svg": "47ce",
	"./images/calm_dude.svg": "a607",
	"./images/card-dark-edge.svg": "8b2e",
	"./images/card-gray-edge.svg": "f253",
	"./images/card-white-edge.svg": "0528",
	"./images/clients/cm.svg": "5d6d",
	"./images/clients/coin-keeper.svg": "f23f",
	"./images/clients/crocus.svg": "9dfe",
	"./images/clients/data-solution.svg": "6aa0",
	"./images/clients/embria.svg": "fa37",
	"./images/clients/first-tv.svg": "ceed",
	"./images/clients/glispa.svg": "d785",
	"./images/clients/herocraft.svg": "cea0",
	"./images/clients/i-digital.svg": "37e7",
	"./images/clients/i-free.svg": "3327",
	"./images/clients/ifree.svg": "afe3",
	"./images/clients/just-ai.svg": "a241",
	"./images/clients/last-backend.svg": "cf0d",
	"./images/clients/my-games.svg": "6a89",
	"./images/clients/nalunch.svg": "30b6",
	"./images/clients/ottmedia.png": "98e5",
	"./images/clients/sber-chorus.svg": "81ab",
	"./images/clients/space307.svg": "46d4",
	"./images/clients/sum-and-substance.svg": "0554",
	"./images/clients/trading-view.svg": "2a31",
	"./images/clients/wallet.svg": "96f3",
	"./images/clients/ya.svg": "e197",
	"./images/clients/zillion-whales.svg": "ca8b",
	"./images/cloud-after.svg": "7806",
	"./images/cloud.svg": "9853",
	"./images/complex-plan.svg": "bd5e",
	"./images/events/event_1.jpg": "d540",
	"./images/events/event_2.jpg": "68fa",
	"./images/events/event_3.jpg": "8c2a",
	"./images/events/event_4.jpg": "1529",
	"./images/faces/Shonin.png": "0b69",
	"./images/faces/gorlina.png": "3ab3",
	"./images/faces/petrov.jpg": "d6ce",
	"./images/faces/umanova.png": "ede5",
	"./images/faces/yurkova.png": "246f",
	"./images/finance-price-dude.svg": "bccd",
	"./images/header_people.png": "abdd",
	"./images/help-desk-hand.svg": "3f00",
	"./images/hr-managment.svg": "7bd7",
	"./images/icons/blockchain.svg": "5433",
	"./images/icons/check_circle.svg": "dcc3",
	"./images/icons/codes.svg": "e8e5",
	"./images/icons/e-commerce.svg": "c56a",
	"./images/icons/feature_1.svg": "e949",
	"./images/icons/feature_2.svg": "be2b",
	"./images/icons/feature_3.svg": "cfc2",
	"./images/icons/fin-tech.svg": "6e69",
	"./images/icons/fmcg.svg": "680f",
	"./images/icons/game-devs.svg": "7a91",
	"./images/icons/list_arrow.svg": "52e7",
	"./images/icons/list_check.svg": "757e",
	"./images/icons/mob-apps.svg": "73d6",
	"./images/icons/saas-paas.svg": "7df2",
	"./images/icons/sms.svg": "f35f",
	"./images/icons/soft-devs.svg": "3efa",
	"./images/icons/spam-it.svg": "b06c",
	"./images/icons/spam.svg": "2f39",
	"./images/icons/startups.svg": "4144",
	"./images/icons/telegram.svg": "14ac",
	"./images/icons/viber.svg": "2b6e",
	"./images/icons/whatsapp.svg": "bdf8",
	"./images/ilegal-dude.svg": "aed6",
	"./images/key-dude.svg": "e582",
	"./images/news/event_1.jpg": "7d36",
	"./images/news/event_2.jpg": "0c47",
	"./images/news/event_3.jpg": "542e",
	"./images/news/event_4.jpg": "5b47",
	"./images/news/large/Design/event_3.jpg": "469b",
	"./images/news/large/first.jpg": "4165",
	"./images/office-managment.svg": "1466",
	"./images/pro_acountants.svg": "d0cb",
	"./images/pro_devops.svg": "1349",
	"./images/pro_it.svg": "ef49",
	"./images/pro_legals.svg": "0039",
	"./images/process_team.svg": "bbb9",
	"./images/quotes.svg": "14b6",
	"./images/quotes_gray.svg": "4ea9",
	"./images/reviews/i-digital.svg": "45ec",
	"./images/reviews/na-lunch.svg": "43a6",
	"./images/reviews/nda.svg": "4568",
	"./images/reviews/zillion-whales.svg": "e347",
	"./images/right_dude.svg": "04a5",
	"./images/services-man.svg": "8307",
	"./images/steps.svg": "c369",
	"./images/sub-arr.svg": "f02f",
	"./images/support-dude.svg": "ca0a",
	"./images/teams/finances/dementieva.jpg": "8095",
	"./images/teams/finances/dolonskaya.jpg": "daa5",
	"./images/teams/finances/petrova.jpg": "9d41",
	"./images/teams/finances/umanova.jpg": "d688",
	"./images/teams/ilegal/ivanova.jpg": "bc73",
	"./images/teams/ilegal/kuznetsova.jpg": "90e6",
	"./images/teams/ilegal/ordovskaya.jpg": "01a2",
	"./images/teams/ilegal/tamulevichus.jpg": "67f8",
	"./images/teams/ilegal/tarakanov.jpg": "e75c",
	"./images/teams/ilegal/utnacunova.jpg": "8141",
	"./images/teams/ilegal/utnasunova.jpg": "ce6e",
	"./images/teams/ilegal/yurkova.jpg": "b1a7",
	"./images/teams/offices/gorlina.jpg": "e26d",
	"./images/teams/offices/mihalich.jpg": "4580",
	"./images/teams/support/belokobylskaya.jpg": "2efc",
	"./images/teams/support/belskaya.jpg": "d678",
	"./images/teams/support/ignatev.jpg": "9ded",
	"./images/teams/support/kaloshin.jpg": "0951",
	"./images/teams/support/pastor.jpg": "0497",
	"./images/teams/support/sedov.jpg": "1cdc",
	"./images/teams/support/shonin.jpg": "2d9d",
	"./images/teams/support/sineoki.jpg": "e6d5",
	"./images/tech-features/feature_0.svg": "f43b",
	"./images/tech-features/feature_1.svg": "a420",
	"./images/tech-features/feature_2.svg": "fd5c",
	"./images/tech-word.svg": "bbd8",
	"./images/tiny_arrow.svg": "fea8",
	"./images/white-arrow.svg": "62ba",
	"./logo-ispace-finances.svg": "9468",
	"./logo-ispace-legal.svg": "c8f9",
	"./logo-ispace-tech.svg": "754f",
	"./logo-ispace.svg": "b81f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";